// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K9y2FcO74hSRrctE {
  padding: 24px 16px;
  text-align: left;
}
.NktdhjsMgOEw2QgH {
  display: flex;
}
.VZ4O7Xj9Vn8ophHY {
  display: flex;
  color: #999;
  font-weight: bold;
  line-height: 16px;
  margin-bottom: 7px;
  padding-left: 8px;
  font-size: 12px;
}
.SZUkZz_PBBccojAk {
  display: flex;
  color: #999;
  padding-left: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #666;
}
.SZUkZz_PBBccojAk > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.SZUkZz_PBBccojAk .kdIGNKa71N4GhnXf {
  font-weight: bold;
  color: #333333;
  display: flex;
  align-items: center;
}
.SZUkZz_PBBccojAk .kdIGNKa71N4GhnXf span {
  display: block;
  vertical-align: middle;
  margin-left: 16px;
}
.SZUkZz_PBBccojAk .kdIGNKa71N4GhnXf i {
  font-style: normal;
  width: 32px;
  height: 16px;
  border-radius: 2px;
  opacity: 1;
  line-height: 16px;
  background: #ff6200;
  color: #fff;
  text-align: center;
  display: block;
  vertical-align: middle;
  margin-left: 10px;
}
.SZUkZz_PBBccojAk .i1l_vDjnOISOnSpm {
  color: #0095fc;
  cursor: pointer;
}
.SZUkZz_PBBccojAk .ChOU8XzAPtoiNqQA {
  color: #ff6200;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.SZUkZz_PBBccojAk .QRlNnlLMwcBibDsi {
  color: #666;
}
.SZUkZz_PBBccojAk .GtU1CMLMNOARiuLY {
  color: #ff6200;
}
.SZUkZz_PBBccojAk .jS2bxsB2ud8fN4wd {
  color: #ff0000;
}
.SZUkZz_PBBccojAk .qeWk2yGe9QYcWFnZ {
  color: #30bf75;
}
.SZUkZz_PBBccojAk .MtLHn_L2DmAZ91xh {
  color: #ff0000;
}
.SZUkZz_PBBccojAk .n74HiLp7ChUGugwu {
  color: #0095fc;
  cursor: pointer;
}
.SZUkZz_PBBccojAk .Z4lf4zU2g58s5xkh {
  color: #DBDBDB;
}
.kdIGNKa71N4GhnXf {
  width: 232px;
}
.kdIGNKa71N4GhnXf img {
  width: 32px;
  height: 32px;
}
.MYMT3qtLIh8gXorn {
  width: 124px;
}
.vbho3XC0JBEocq_u {
  width: 148px;
}
.XzGfKoGFEcGADvDd {
  width: 216px;
}
.i1l_vDjnOISOnSpm {
  width: 134px;
}
.ChOU8XzAPtoiNqQA {
  flex: 1;
}
.n74HiLp7ChUGugwu {
  flex: 1;
}
.wt9YwJp9CDAGYntF {
  padding-left: 8px;
}
.vdkBbN84MpMN9VBv {
  background: #f4f7fb;
  line-height: 48px;
}
.XeHau0PM0rkPS_MH {
  width: 16px;
  vertical-align: middle;
  margin-top: -2px;
}
.lomdrYPF6XgZ9OVl {
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
  cursor: pointer;
}
.LXu7HKrp7lg2q9Pw {
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  padding: 11px 16px 13px;
  border-radius: 8px;
  opacity: 1;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #dfe3e7;
  position: absolute;
  right: -64px;
  top: 3px;
  line-height: 16px;
  color: #333;
}
.qIQOiiN90IkUqZcf {
  position: relative;
}
.qIQOiiN90IkUqZcf .LXu7HKrp7lg2q9Pw {
  visibility: hidden;
}
.qIQOiiN90IkUqZcf:hover .LXu7HKrp7lg2q9Pw {
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/Table/index.modules.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;AACA;EACE,aAAA;AACF;AACA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AACF;AACA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AACF;AAPA;EAQI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;AAZA;EAaI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAEJ;AAlBA;EAkBM,cAAA;EACA,sBAAA;EACA,iBAAA;AAGN;AAvBA;EAuBM,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AAGN;AArCA;EAsCI,cAAA;EACA,eAAA;AAEJ;AAzCA;EA0CI,cAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AAEJ;AA/CA;EAgDI,WAAA;AAEJ;AAlDA;EAmDI,cAAA;AAEJ;AArDA;EAsDI,cAAA;AAEJ;AAxDA;EAyDI,cAAA;AAEJ;AA3DA;EA4DI,cAAA;AAEJ;AA9DA;EA+DI,cAAA;EACA,eAAA;AAEJ;AAlEA;EAmEI,cAAA;AAEJ;AACA;EACE,YAAA;AACF;AAFA;EAII,WAAA;EACA,YAAA;AACJ;AAEA;EACE,YAAA;AAAF;AAEA;EACE,YAAA;AAAF;AAEA;EACE,YAAA;AAAF;AAEA;EACE,YAAA;AAAF;AAEA;EAEE,OAAA;AADF;AAGA;EACE,OAAA;AADF;AAGA;EACE,iBAAA;AADF;AAGA;EACE,mBAAA;EACA,iBAAA;AADF;AAGA;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;AADF;AAGA;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;AADF;AAIA;EACE,8CAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;AAFF;AAIA;EACE,kBAAA;AAFF;AACA;EAGI,kBAAA;AADJ;AAGE;EAEI,mBAAA;AAFN","sourcesContent":[".normal_list {\n  padding: 24px 16px;\n  text-align: left;\n}\n.item {\n  display: flex;\n}\n.l_header {\n  display: flex;\n  color: #999;\n  font-weight: bold;\n  line-height: 16px;\n  margin-bottom: 7px;\n  padding-left: 8px;\n  font-size: 12px;\n}\n.l_item {\n  display: flex;\n  color: #999;\n  padding-left: 8px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  color: #666;\n  > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .l_name {\n    font-weight: bold;\n    color: #333333;\n    display: flex;\n    align-items: center;\n    span {\n      display: block;\n      vertical-align: middle;\n      margin-left: 16px;\n    }\n    i {\n      font-style: normal;\n      width: 32px;\n      height: 16px;\n      border-radius: 2px;\n      opacity: 1;\n      line-height: 16px;\n      background: #ff6200;\n      color: #fff;\n      text-align: center;\n      display: block;\n      vertical-align: middle;\n      margin-left: 10px;\n    }\n  }\n  .l_info {\n    color: #0095fc;\n    cursor: pointer;\n  }\n  .l_state {\n    color: #ff6200;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  .config_1 {\n    color: #666;\n  }\n  .config_2 {\n    color: #ff6200;\n  }\n  .config_3 {\n    color: #ff0000;\n  }\n  .config_4 {\n    color: #30bf75;\n  }\n  .config_5 {\n    color: #ff0000;\n  }\n  .l_btn {\n    color: #0095fc;\n    cursor: pointer;\n  }\n  .disable {\n    color: #DBDBDB;\n  }\n}\n.l_name {\n  width: 232px;\n  // padding-left: 8px;\n  img {\n    width: 32px;\n    height: 32px;\n  }\n}\n.l_type {\n  width: 124px;\n}\n.l_version {\n  width: 148px;\n}\n.l_time {\n  width: 216px;\n}\n.l_info {\n  width: 134px;\n}\n.l_state {\n  // width: 159px;\n  flex: 1;\n}\n.l_btn {\n  flex: 1;\n}\n.p8 {\n  padding-left: 8px;\n}\n.bg {\n  background: #f4f7fb;\n  line-height: 48px;\n}\n.audit_failed {\n  width: 16px;\n  vertical-align: middle;\n  margin-top: -2px;\n}\n.audit {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 4px;\n  cursor: pointer;\n  \n}\n.reason {\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);\n  padding: 11px 16px 13px;\n  border-radius: 8px;\n  opacity: 1;\n  background: #ffffff;\n  box-sizing: border-box;\n  border: 1px solid #dfe3e7;\n  position: absolute;\n  right: -64px;\n  top: 3px;\n  line-height: 16px;\n  color: #333;\n}\n.auditBox {\n  position: relative;\n  .reason {\n    visibility: hidden;\n  }\n  &:hover {\n    .reason {\n      visibility: visible;\n    }\n  }\n \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"normal_list": `K9y2FcO74hSRrctE`,
	"item": `NktdhjsMgOEw2QgH`,
	"l_header": `VZ4O7Xj9Vn8ophHY`,
	"l_item": `SZUkZz_PBBccojAk`,
	"l_name": `kdIGNKa71N4GhnXf`,
	"l_info": `i1l_vDjnOISOnSpm`,
	"l_state": `ChOU8XzAPtoiNqQA`,
	"config_1": `QRlNnlLMwcBibDsi`,
	"config_2": `GtU1CMLMNOARiuLY`,
	"config_3": `jS2bxsB2ud8fN4wd`,
	"config_4": `qeWk2yGe9QYcWFnZ`,
	"config_5": `MtLHn_L2DmAZ91xh`,
	"l_btn": `n74HiLp7ChUGugwu`,
	"disable": `Z4lf4zU2g58s5xkh`,
	"l_type": `MYMT3qtLIh8gXorn`,
	"l_version": `vbho3XC0JBEocq_u`,
	"l_time": `XzGfKoGFEcGADvDd`,
	"p8": `wt9YwJp9CDAGYntF`,
	"bg": `vdkBbN84MpMN9VBv`,
	"audit_failed": `XeHau0PM0rkPS_MH`,
	"audit": `lomdrYPF6XgZ9OVl`,
	"reason": `LXu7HKrp7lg2q9Pw`,
	"auditBox": `qIQOiiN90IkUqZcf`
};
export default ___CSS_LOADER_EXPORT___;
